"use client";

import type { OrderBlockDoc as OrderBlockProps } from "../../types/blocks";

export const OrderBlock: React.FC<OrderBlockProps> = () => {
  return null;
};
